import API from 'services/AUTH_API';

export default function getCaptcha(inn) {
  return API.request({
    method: 'GET',
    url: `/captcha?username=${inn}`,
    responseType: 'arraybuffer',
    mapper: (data) => {
      const bytes = new Uint8Array(data);
      const binary = [].map.call(bytes, (byte) => String.fromCharCode(byte)).join('');
      return `data:image/png;base64,${btoa(binary)}`;
    },
  });
}
